import {createApp} from 'vue';
import PermanentChat from '../components/agent/ChatAgent.vue';

document.addEventListener('turbo:load', () => {
    const mountPoint = document.getElementById('permanent-chat-root');

    // Only mount if it hasn't been mounted yet
    if (mountPoint && !mountPoint.dataset.vueMounted) {
        const app = createApp(PermanentChat);
        app.mount(mountPoint);
        mountPoint.dataset.vueMounted = 'true'; // Flag to prevent multi-mounting
    }
});